export default __webpack_public_path__ + "static/media/feedback.ded9a3f8.svg";